/**
 * 图生文工具任务相关类型定义
 */

// ==================== 工具类型 ====================

export const IMAGE_TO_TEXT_TOOL_TYPE = {
  PRODUCT_TITLE: 'product_title',
  REVERSE_PROMPT: 'reverse_prompt',
  INFRINGEMENT: 'infringement',
} as const

export type ImageToTextToolType =
  (typeof IMAGE_TO_TEXT_TOOL_TYPE)[keyof typeof IMAGE_TO_TEXT_TOOL_TYPE]

export const IMAGE_TO_TEXT_TOOL_TYPE_LABELS: Record<ImageToTextToolType, string> = {
  product_title: '商品标题生成',
  reverse_prompt: '提示词反推',
  infringement: '侵权检测',
}

// ==================== 批量任务状态 ====================

export const IMAGE_TO_TEXT_TASK_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  PARTIAL_FAILED: 'partial_failed',
  FAILED: 'failed',
} as const

export type ImageToTextTaskStatus =
  (typeof IMAGE_TO_TEXT_TASK_STATUS)[keyof typeof IMAGE_TO_TEXT_TASK_STATUS]

export const IMAGE_TO_TEXT_TASK_STATUS_LABELS: Record<
  ImageToTextTaskStatus,
  { text: string; color: string }
> = {
  pending: { text: '等待中', color: 'text-muted-foreground' },
  running: { text: '处理中', color: 'text-blue-600 dark:text-blue-400' },
  completed: { text: '已完成', color: 'text-green-600 dark:text-green-400' },
  partial_failed: { text: '部分失败', color: 'text-amber-600 dark:text-amber-400' },
  failed: { text: '全部失败', color: 'text-destructive' },
}

export function isImageToTextTaskTerminal(status: ImageToTextTaskStatus): boolean {
  return status === 'completed' || status === 'partial_failed' || status === 'failed'
}

// ==================== 子任务状态 ====================

export const IMAGE_TO_TEXT_ITEM_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const

export type ImageToTextItemStatus =
  (typeof IMAGE_TO_TEXT_ITEM_STATUS)[keyof typeof IMAGE_TO_TEXT_ITEM_STATUS]

// ==================== 实体类型 ====================

export interface ImageToTextTask {
  id: string
  user_id: string
  company_id: string
  tool_type?: ImageToTextToolType  // optional, kept for backward compat with old records
  tool_types: ImageToTextToolType[] // ordered list of selected tool types
  status: ImageToTextTaskStatus
  total_count: number
  completed_count: number
  failed_count: number
  remark: string
  created_at: string
  updated_at: string
  completed_at: string | null
}

export interface ImageToTextTaskItem {
  id: string
  batch_task_id: string
  item_index: number
  image_index: number
  tool_type: ImageToTextToolType
  image_url: string
  original_filename: string
  status: ImageToTextItemStatus
  result: string
  error: string
  task_id: string
  created_at: string
  updated_at: string
}

// ==================== 请求/响应类型 ====================

export interface SubmitImageItem {
  url: string
  original_filename: string
}

export interface SubmitImageToTextTaskRequest {
  tool_types: ImageToTextToolType[]
  images: SubmitImageItem[]
  remark?: string
}

export interface SubmitImageToTextTaskResponse {
  id: string
  status: ImageToTextTaskStatus
  total_count: number
}

export interface ImageToTextTaskDetailResponse {
  task: ImageToTextTask
  items: ImageToTextTaskItem[]
}

export interface ImageToTextTaskListResponse {
  items: ImageToTextTask[]
  total: number
  page: number
  page_size: number
}
